import { jsx as _jsx } from "react/jsx-runtime";
export function Link(props) {
    return _jsx("a", Object.assign({}, props));
}
